import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import { PrintSettingsStateTypes } from "../types/print_settings";

interface BarcodeProps {
  value: string;
  type: string;
  settings: PrintSettingsStateTypes;
}
function RenderBarcode(props: BarcodeProps) {
  const { value, type, settings } = props;
  if (!value || value.length === 0) {
    return <></>;
  }
  return (
    <>
      {type === "QR" ? (
        <div className="bg-white p-2 flex flex-col items-center">
          <QRCode value={value} size={settings?.barcodeHeight} />
          {settings.showCode && (
            <div style={{ fontSize: settings.fontSize, marginTop: 5 }}>
              {value}
            </div>
          )}
        </div>
      ) : (
        <Barcode
          value={value}
          displayValue={settings.showCode}
          height={settings?.barcodeHeight}
          width={settings?.barcodeWidth}
          fontSize={settings?.fontSize}
          format={type as any}
        />
      )}
    </>
  );
}

export default RenderBarcode;
